import { useEffect, useState } from 'react';
import { isMobile, isInAppWebView, isPWADisplayMode } from '../utils/envDetect';

const KEY = 'appBanner:dismissed';

export function useShowAppBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY) === '1') return;
    const ok = isMobile() && !isInAppWebView() && !isPWADisplayMode();
    setShow(ok);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, '1');
    setShow(false);
  };

  return { show, dismiss };
}
